import React, { FC, useState } from 'react';
import { CgEthernet } from 'react-icons/cg';
import { MdSettingsEthernet } from 'react-icons/md';
import { PiNetworkLight } from 'react-icons/pi';
import { useDispatch } from 'react-redux';
import {
  DomotzDevice,
  DomotzDeviceList,
  NetworkDeviceTableHeadersType,
} from '../../interfaces/NetworkDevices';
import { setRootAside } from '../../state/component/AsideSlice';
import ListComponent from '../../utils/ListComponent';
import Tag from '../tags/Tag';
import Typography from '../typography/Typography';
import Table from './Table';
import TableItem from './TableItem';
import TableRow from './TableRow';

interface devices {
  devices: DomotzDeviceList;
}

const NetworkDevicesTable: FC<devices> = ({ devices }) => {
  const dispatch = useDispatch();
  const [hoveredUplinkId, setHoveredUplinkId] = useState<number | null>(null);

  const tableHeaders: NetworkDeviceTableHeadersType[] = [
    'Network device',
    'Status',
    'Uplink',
    'IP Address',
    'Type',
    'Vendor',
    'Connections',
  ];

  const setDetail = (device: DomotzDevice) => {
    dispatch(
      setRootAside({
        component: 'networkDeviceDetailContainer',
        data: { device },
        title: 'Network device',
      })
    );
  };

  return (
    <>
      <Table header={tableHeaders}>
        <ListComponent
          data={devices}
          renderItem={(item: DomotzDevice) => (
            <TableRow key={item.id} onClick={() => setDetail(item)}>
              <TableItem>
                <Tag
                  label={item.display_name}
                  style={hoveredUplinkId === item.id ? 'new' : 'neutral'}
                />
              </TableItem>
              <TableItem>
                <Tag style={item.status} label={item.status} />
              </TableItem>
              <TableItem>
                {item.uplink && item.uplink.length > 0 ? (
                  <div
                    className="group"
                    onMouseEnter={() => setHoveredUplinkId(item.uplink[0].id)}
                    onMouseLeave={() => setHoveredUplinkId(null)}
                  >
                    <Tag
                      icon={
                        <CgEthernet
                          className={`group-hover:-rotate-90 transition-transform group-hover:text-green-500 ${hoveredUplinkId === item.id ? '-rotate-90 transition-transform text-green-500' : ''}`}
                        />
                      }
                      label={item.uplink[0].display_name}
                      style="default"
                    />
                  </div>
                ) : (
                  ''
                )}
              </TableItem>

              <TableItem>
                <ListComponent
                  data={item.ip_addresses}
                  renderItem={(ip) => (
                    <span className="ml-2">
                      <Typography tag="span" type="label">
                        {ip}
                      </Typography>
                    </span>
                  )}
                />
              </TableItem>
              <TableItem>
                <Typography tag="span" type="label">
                  {item.type?.label}
                </Typography>
              </TableItem>
              <TableItem>
                <Typography tag="span" type="label">
                  {item.vendor}
                </Typography>
              </TableItem>
              <TableItem>
                <Tag
                  icon={
                    hoveredUplinkId === item.id ? (
                      <MdSettingsEthernet />
                    ) : (
                      <PiNetworkLight />
                    )
                  }
                  label={item.connected_to?.length}
                  style={hoveredUplinkId === item.id ? 'new' : 'default'}
                />
              </TableItem>
              {/* <TableItem>
                {item.snmp_status === 'AUTHENTICATED' ? (
                  <Unlock size={16} className="text-green-500" />
                ) : (
                  <Lock size={16} className="text-red-500" />
                )}
              </TableItem> */}
            </TableRow>
          )}
        />
      </Table>
    </>
  );
};

export default NetworkDevicesTable;
